import React from 'react';
import '../styles/css/index.css';

import HeaderComponent from '../components/HeaderComponent';
import FooterComponent from '../components/FooterComponent';

import GalleryComponent from '../components/GalleryComponent';


function Rooms() {
    return (
        <React.Fragment>
            <HeaderComponent />
              <GalleryComponent />
            <FooterComponent />
        </React.Fragment>
    );
}

export default Rooms;
